// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PushpinTwoToneSvg from "@ant-design/icons-svg/es/asn/PushpinTwoTone";
import AntdIcon from '../components/AntdIcon';

var PushpinTwoTone = function PushpinTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PushpinTwoToneSvg
  }));
};

PushpinTwoTone.displayName = 'PushpinTwoTone';
export default React.forwardRef(PushpinTwoTone);